import { DynamicFieldInstruction } from './shared';
export class InputSwitchInstruction extends DynamicFieldInstruction {
  constructor(config) {
    super();
    /** object map of input name -> source name / function */
    this.inputMap = {
      labels: 'inlineLabels'
    };
    this.attributeMap = {};
    this.setConfig(config);
  }
  load() {
    return import(/* webpackChunkName: "ui-input-switch" */
    /* webpackMode: "lazy" */
    '@common/ui/frontend-shared/input-switch').then(m => m.UiInputSwitchComponent);
  }
}